import { add, qs, qsa, remove } from "@fluorescent/dom";

const selectors = {
  imageById: id => `[data-media-id='${id}']`,
  imageWrapper: "[data-product-media-wrapper]",
  inYourSpace: "[data-in-your-space]",
};

const classes = {
  hidden: "hidden",
};

export default function (container, imageId) {
  const newImage = qs(
    selectors.imageWrapper + selectors.imageById(imageId),
    container
  );

  const newImageMedia = qs(".media", newImage);

  const otherImages = qsa(
    `${selectors.imageWrapper}:not(${selectors.imageById(imageId)})`,
    container
  );

  remove(newImage, classes.hidden);

  // Update view in space button
  const inYourSpaceButton = qs(selectors.inYourSpace, container);

  if (inYourSpaceButton) {
    if (newImageMedia.dataset.mediaType === "model") {
      inYourSpaceButton.setAttribute(
        "data-shopify-model3d-id",
        newImageMedia.dataset.mediaId
      );
    }
  }

  otherImages.forEach(image => add(image, classes.hidden));
}
